<button [class]="customClass ? customClass : 'btn-primary'" [dataHook]="translationKey" [disabled]="isDisabled"
  (mouseenter)="iconColor = activeConfig?.hoverColor || activeConfig?.color"
  (mouseleave)="iconColor = activeConfig?.color" [ngClass]="buttonClasses" [type]="customType" class="btn">
  <div class="d-flex align-items-center flex-nowrap justify-content-center">
    <ng-container>
      <ng-content></ng-content>
      <circle-progress *ngIf="inProgress && !iconSuffixConfig?.name && !iconPrefixConfig?.name" class="spinner centered"
        [percent]="20" [maxPercent]="100" [radius]="9" [innerStrokeWidth]="3" [space]="'-3'"
        [outerStrokeColor]="spinnerColor?.outer" [innerStrokeColor]="spinnerColor?.inner"
        [outerStrokeWidth]="3"></circle-progress>
      <div class="icon-loader-wrapper-prefix" *ngIf="iconPrefixConfig?.name">
        <circle-progress *ngIf="inProgress && iconPrefixConfig?.name" class="spinner d-block" [percent]="20"
          [maxPercent]="100" [radius]="9" [innerStrokeWidth]="3" [space]="'-3'" [outerStrokeColor]="spinnerColor?.outer"
          [innerStrokeColor]="spinnerColor?.inner" [outerStrokeWidth]="3"></circle-progress>
        <ng-icon *ngIf="!inProgress && iconPrefixConfig?.name" [name]="iconPrefixConfig?.name"
          [size]="iconPrefixConfig?.size" [strokeWidth]="iconPrefixConfig?.strokeWidth"
          [color]="isDisabled ? iconPrefixConfig?.disabledStateColor : iconColor"></ng-icon>
      </div>
      <img *ngIf="!inProgress && iconPrefix" [src]="iconPrefix" class="mr-1">
      <span [ngClass]="{'rosie-invisible': inProgress && !iconSuffixConfig?.name && !iconPrefixConfig?.name}">{{
        translationKey | translate
        }}</span>
      <div class="icon-loader-wrapper-suffix" *ngIf="iconSuffixConfig?.name">
        <ng-icon *ngIf="!inProgress && iconSuffixConfig?.name" [name]="iconSuffixConfig?.name"
          [size]="iconSuffixConfig?.size" [strokeWidth]="iconSuffixConfig?.strokeWidth"
          [color]="isDisabled ? iconSuffixConfig?.disabledStateColor : iconColor"></ng-icon>
        <circle-progress *ngIf="inProgress" class="spinner d-block" [percent]="20" [maxPercent]="100" [radius]="9"
          [innerStrokeWidth]="3" [space]="'-3'" [outerStrokeColor]="spinnerColor?.outer"
          [innerStrokeColor]="spinnerColor?.inner" [outerStrokeWidth]="3"></circle-progress>
      </div>
    </ng-container>
  </div>
</button>